<div *ngIf="loading" class="playlist-grid">
  <div class="skeleton-card" *ngFor="let s of skeletons">
    <div class="skeleton-cover"></div>
    <div class="skeleton-line short"></div>
    <div class="skeleton-line long"></div>
  </div>
</div>

<div *ngIf="!loading && visiblePlaylists.length === 0" class="empty-state">
  <span class="empty-vinyl">&#9673;</span>
  <p class="empty-title">No playlists yet</p>
  <p class="empty-sub">Check back soon — something is always being curated.</p>
</div>

<div *ngIf="!loading && visiblePlaylists.length > 0" class="playlist-grid">
  <a
    *ngFor="let playlist of visiblePlaylists"
    [href]="playlist.externalLink"
    target="_blank"
    rel="noopener noreferrer"
    class="playlist-card"
    [class.playlist-card--featured]="playlist.featured"
    [attr.aria-label]="playlist.title + ' on ' + getPlatformLabel(playlist.platform)">
    <div class="cover-wrap">
      <img *ngIf="playlist.coverImageUrl" [src]="playlist.coverImageUrl" [alt]="playlist.title" class="cover-img" loading="lazy" />
      <div *ngIf="!playlist.coverImageUrl" class="cover-placeholder">
        <span class="placeholder-vinyl">&#9673;</span>
      </div>
      <span *ngIf="playlist.featured" class="featured-badge"><i class="bi bi-star-fill"></i></span>
      <div class="cover-overlay">
        <i [class]="'platform-icon ' + getPlatformIcon(playlist.platform)"></i>
        <span class="listen-label">Listen</span>
      </div>
    </div>
    <div class="card-info">
      <span class="card-period text-label">{{ playlist.month }} {{ playlist.year }}</span>
      <p class="card-title">{{ playlist.title }}</p>
      <span class="card-platform">
        <i [class]="getPlatformIcon(playlist.platform)"></i>
        {{ getPlatformLabel(playlist.platform) }}
      </span>
    </div>
  </a>
</div>
